import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUser } from 'slices/userSlice';
import Api from 'services/api';

const ImpersonationBanner = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const adminSession = (() => {
        try { return JSON.parse(localStorage.getItem('admin_session')); } catch { return null; }
    })();

    if (!adminSession) return null;

    const handleReturn = () => {
        Api.setClientToken(adminSession.token);
        dispatch(setUser({ data: adminSession.user }));
        localStorage.removeItem('admin_session');
        navigate('/');
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            background: '#d63031',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 20px',
            fontSize: '14px',
            fontWeight: 500,
        }}>
            <span>
                👁 Ghost mode — logged in as <strong>{adminSession.interpreterName}</strong>
            </span>
            <button
                onClick={handleReturn}
                style={{
                    background: '#fff',
                    color: '#d63031',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '4px 14px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontSize: '13px',
                }}
            >
                Return to Admin
            </button>
        </div>
    );
};

export default ImpersonationBanner;
